import { ColumnList } from "components/ColumnList"
import { ColumnListColumn } from "components/ColumnList/types"
import { OrderCellStatus } from "components/Orders/Orders/Components/OrderCellStatus"

import { Order } from "../types"

export const History = ({ order }: { order?: Order }) => {
    if (!order) return null;

    const columns: ColumnListColumn[] = [
        { header: '', accessor: 'date', align: 'left', flex: 6 },
        {
            header: '',
            accessor: 'status',
            align: 'left',
            render: (value) => <OrderCellStatus status={value} />,
            flex: 3,
        },
        { header: '', accessor: 'event', align: 'left', flex: 4 },
    ]

    const historyData = order.history.map((history, index) => ({
        date: new Date(history.createdAt).toLocaleString(),
        status: history.status,
        event: history.event || '-',
        id: `${history.createdAt}-${index}`,
        dateDataTestId: `historyDate-${index}`,
        statusDataTestId: `historyStatus-${index}`,
        eventDataTestId: `historyEvent-${index}`
    }))

    return (
        <div className="flex flex-col gap-4 p-6 pb-8 border border-base-sidebarBorder rounded-lg">
            <h2 className="font-medium text-xl text-base-primary">History</h2>
            <div className="flex flex-col gap-4">
                <ColumnList columns={columns} data={historyData} />
            </div>
        </div>
    )
}
